import { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { AuthContext } from './Authentication';

const Verification = () => {
    
    const [verificationCode, setVerificationCode] = useState('');
    const { user, username } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("username ", username);
        confirmSignUp();
    }

    async function confirmSignUp() {
        console.log("Mandando username ", username, ", codigo ", verificationCode);
        try {
            await Auth.confirmSignUp(username, verificationCode)
            .then(() => {
                console.log("Confirmou o registro");
                navigate("/painel");
            });
        } catch (error) {
            console.log('error confirming sign up', error);
        }
    }

    return ( 
        <div className="login">
        <h2>Confirmação de conta</h2>
        <h2>Verifique seu e-mail e insira o código de 6 dígitos para fazermos a ativação da conta</h2>
        <form onSubmit={handleSubmit}>
            <label>Código de verificação:</label>
            <input
                required
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
            />
            <input type="submit" value="Verificar"></input>
        </form>        
    </div>
     );
}
 
export default Verification;